<template>
  <div class="grid">
    <div class="header">
      <the-header />
    </div>
    <div class="map">
      <the-map />
    </div>
    <div class="footer">
      <vs-collapse>
        <vs-collapse-item class="collapse-panel">
          <div slot="header" class="footer-header">
            <!-- <i class="material-icons">baseline_waves</i> -->
            <img src="@/assets/blue_time_machine_alt4.png" />
            <span>Blue Time Machine</span>
          </div>
          <vs-divider class="panel-separator" color="#19535f" />
          <blue-time-machine />
        </vs-collapse-item>
      </vs-collapse>
    </div>
    <the-home :auto-open="false" />
    <the-about :auto-open="false" />
    <the-science :auto-open="false" />
    <the-loader />
  </div>
</template>
<script>
import TheHeader from "@/views/TheHeader";
import TheBTM from "@/views/BlueTimeMachine/TheBTM";
import TheHome from "@/views/TheHome";
import TheAbout from "@/views/TheAbout";
import TheLoader from "@/views/TheLoadBar";
import TheScience from "@/views/TheScience";
import TheMap from "@/views/TheMap";

export default {
  name: "App",
  components: {
    TheHeader,
    "blue-time-machine": TheBTM,
    TheHome,
    TheAbout,
    TheLoader,
    TheScience,
    TheMap
  }
};
</script>
<style>
.footer-header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
}

.footer-header span {
  color: #19535f;
  font-weight: bold;
}

.footer-header img {
  max-width: 30px;
  margin-right: 1rem;
}

.vs-collapse .open-item {
  box-shadow: none;
  /* min-height: 471px; */
}

.vs-collapse .open-item .vs-collapse-item--content {
  max-height: fit-content !important;
  max-height: -moz-fit-content !important;
}

.vs-collapse .open-item .vs-collapse-item--header {
  padding-top: 0;
}

.collapse-panel .con-content--item {
  padding-bottom: 0;
}

.panel-separator {
  margin-top: 0;
  margin-bottom: 10px;
}
</style>
